export const LP_JOURNEY_MODE = 'lp';
export const LP_JOURNEY_SOURCE = 'lp-free-reading';
export const VSL_JOURNEY_SOURCE = 'lp-vsl';

export function isLpJourneySearch(search: string): boolean {
  const params = new URLSearchParams(search);
  return params.get('journey') === LP_JOURNEY_MODE;
}

export function applyLpJourneyParams(params: URLSearchParams): URLSearchParams {
  params.set('journey', LP_JOURNEY_MODE);
  if (!params.get('source')) {
    params.set('source', LP_JOURNEY_SOURCE);
  }

  return params;
}
